import React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import "./OpenPositions.css";
import { columns } from "./columns";

const OpenPositions = ({ openPositionData }) => {
  // Build MUI Data Grid
  const tableColumns = columns;

  const date = new Date();

  return (
    <div className="open-positions">
      <div className="open-positions-header">
        <h1 className="open-positions-title text-header">Open Positions (long)</h1>
        <p className="open-positions-updated-time text-xsmall">
          last update {date.toString()}
        </p>
      </div>
      <div className="table">
        <DataGrid
          rows={openPositionData}
          columns={tableColumns}
          slots={{ toolbar: GridToolbar }}
        />
      </div>
    </div>
  );
};

export default OpenPositions;
